import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";

function MailError() {
    const location = useLocation();
    const { title } = location.state;
    const handleClickBack = () => {
        //eslint-disable-next-line
        history.back();
    };

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <img
                className="logo"
                src={`${process.env.PUBLIC_URL}/kantan_seikyu_logo.png`}
                alt={title}
            />

            <h2>{title}</h2>

            <p className="mail-error-text">
                無料お試しセットの申し込みができませんでした。<br /><br />
                入力されたメールアドレスの形式が正しくありません。<br />
                お手数をおかけしますが、申し込みをやり直してください。
            </p>

            <button
                className="back-button"
                type="button"
                onClick={handleClickBack}
            >
                申し込みをやり直す
            </button>
        </>
    );
}

export default MailError;